import targetAnalysisByOrg from './targetAnalysisByOrg'
import customizeTargetAnalysis from './customizeTargetAnalysis'
import optionsAnalysis from './optionsAnalysis'

export default {
    targetAnalysisByOrg ,
    customizeTargetAnalysis ,
    optionsAnalysis
}